import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-WhenDoIGetReassessed',
    templateUrl: './WhenDoIGetReassessed.component.html',
    styleUrls: ['./WhenDoIGetReassessed.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WhenDoIGetReassessedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
